import Marquee from "react-fast-marquee";

const ITEMS = [
  "Term Life", "Whole Life", "Medicare Solutions", "Final Expense",
  "Individual & Family", "Universal Life", "Vision & Dental", "Supplemental Health",
];

export default function TrustMarquee() {
  return (
    <section aria-label="Coverage highlights" className="bg-navy py-7 border-y border-white/5" data-testid="trust-marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-extrabold text-3xl sm:text-4xl stroke-text mx-8 whitespace-nowrap">
              {item}
            </span>
            <span className="text-gold text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
